import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootStates, AppDispatch } from '.';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): any => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootStates> = useSelector;
